import React from "react";
import {BigTitle} from "../Components/UI";
import {Spacer, ThirdTitle} from "@dspworkplace/ui";
import {Link} from "react-router-dom";

import Logo from "../assets/logo.svg";

const NotFound = () => {
    return (
        <Spacer all={30}>
            <img src={Logo} alt="dspworkplace" height={52}/>
            <Spacer bottom={5}/>
            <BigTitle>Oops...</BigTitle>
            <Spacer bottom={5}/>
            <ThirdTitle>We couldn't find what you were looking for.</ThirdTitle>
            <Spacer bottom={3}/>
            <Link to='/'>Back to the home page</Link>
        </Spacer>
    )
}

export default NotFound;